import { useRef } from 'react';
import { isEqual } from 'lodash';
import { useState, useEffect } from 'react';

import IvrTemplates, { IvrTemplateType } from 'src/presentation/components/pages/ivr/constants/templates';

type NodeListType = {
  label: string;
  value: string;
};

const useCreateNew = ({ nodeList }) => {
  const [newNode, setNewNode] = useState();
  const [options, setOptions] = useState<NodeListType[]>(nodeList);

  const prevOptions = useRef<NodeListType[]>([]);

  useEffect(() => {
    if (!isEqual(prevOptions.current, nodeList)) {
      setOptions(nodeList);
      prevOptions.current = nodeList;
    }
  }, [prevOptions, nodeList, setOptions]);

  const onCreateNewNode = newNode => {
    setNewNode(newNode);
    setOptions([...prevOptions.current, { label: newNode.ivrNode.name, value: newNode.ivrNode.id }]);
  };

  const onCreateNewNodesFromTemplate = (templateType: IvrTemplateType) => {
    setOptions([...prevOptions.current, { label: IvrTemplates[templateType].name, value: templateType.toString() }]);
  };

  return { newNode, options, onCreateNewNode, onCreateNewNodesFromTemplate };
};

export default useCreateNew;
